<template>
  <div class="hello">
      <div class='container'>
            <transition name="fade">
                <div v-if="gettingItems" class="loading">
                    <p>Getting your items...</p>
                </div>
            </transition>
        </div>

    <!-- Modal to manage sale item -->
    
    <b-container>
        
        <b-row>
            <b-col>
                <b-button style="margin-top:20px" variant='success' size='lg' @click="goToAddItem()">Post Something for Sale</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <h4 style="margin-top:10px">Your Items</h4>
            </b-col>
        </b-row>

        <table class="table table-bordered">
            <tbody>
                <template v-for="item in userItemsForSale">
                    <tr :key="item.id" style="cursor:pointer" @click="clickedItem(item)">
                        <td>
                            <h4>{{item.title}}</h4>
                            <!-- If sold -->
                            <div v-if="item.sold" style="color:red"><strong>Sold</strong></div>
                            <div v-else style="color:green"><strong>Ad is Live</strong></div>
                        </td>
                    </tr>
                    <b-modal size='xl' :id="'manageitem'+item.id" :key="'manageitem'+item.id" :hide-footer="true"  :no-close-on-backdrop="true">
                        <Managesaleitem :saleItem="item" @closeManageItemModal="closeManageItemModal" />
                    </b-modal>
                </template>
            </tbody>
        </table>
        
    </b-container>
    <div id="footerid">
        <footer><pagefooter/></footer>
    </div>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import Pagefooter from '../Pagefooter'
import Managesaleitem from './Managesaleitem'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        Pagefooter,
        Managesaleitem,
    },

    data() {
        return {
            //User items for sale
            userItemsForSale:[],
            gettingItems:false,

        }
    },

    methods:{
        goToAddItem(){
            this.$router.push('/additemforsale')
        },

        //get user items for sale
        getItemsForSale(){
            this.gettingItems=true
            var localSalesList=[]
            fb.forSaleCollection.where("uid", "==", this.currentUser.uid).get().then(docs => {
                docs.forEach(doc => {
                    //Get minimum price
                    var saleData = doc.data()
                    saleData.docId = doc.id
                    localSalesList.push(saleData)
                    //Add to brewers list
                })
                })
            .then(res => {
                this.userItemsForSale=localSalesList
                this.gettingItems=false
            }).catch(err => {
                this.gettingItems=false
                console.log("Error getting items")
            })
        },

        //Clicked item
        clickedItem(item){
            console.log("Clicked item")
            this.$bvModal.show("manageitem"+item.id)
        },

        //CLose manage item modal
        closeManageItemModal(id){
            this.$bvModal.hide("manageitem"+id)
            this.getItemsForSale()
        }
    },

    mounted(){
        this.getItemsForSale()
    },
}
</script>

